import React from 'react';
import { Grid3x3Icon, MusicIcon, ShuffleIcon, UsersIcon } from 'lucide-react';
import { Reveal } from './Reveal';
import { upsellFeatures } from '../data/content';
const icons = {
  grid: Grid3x3Icon,
  shuffle: ShuffleIcon,
  users: UsersIcon,
  music: MusicIcon
};
export function UpsellTeaser() {
  return <section className="w-full bg-ink px-5 py-20 text-white sm:px-8" data-id="element-231" data-mp="txws51x81txl">
      <div className="mx-auto w-full max-w-5xl" data-id="element-232" data-mp="3tecwuhfyi4qr">
        <Reveal data-id="element-233" data-mp="3tfo0mh9ejchv">
          <h2 className="text-center font-display text-3xl font-extrabold tracking-tight sm:text-4xl" data-id="element-234" data-mp="3tg6706ps373i">
            Competition Routine <span className="text-cheer" data-id="element-235" data-mp="69dl0ppwrn73">Builder Pro</span>
          </h2>
          <p className="mx-auto mt-4 max-w-xl text-center text-base text-white/60" data-id="element-236" data-mp="6bgke0cyasoh">
            The add-on that turns a good routine into a scoring one.
          </p>
        </Reveal>

        <ul className="mt-12 grid gap-5 sm:grid-cols-2" data-id="element-237" data-mp="1ho0t11j0zfkw">
          {upsellFeatures.map((feature, index) => {
          const Icon = icons[feature.icon as keyof typeof icons];
          return <Reveal key={feature.title} delay={index % 2 * 0.05} className="h-full" data-id="element-238" data-mp="1vxn4tp7zt7rs" data-mpi={index}>
                <li className="flex h-full items-start gap-4 rounded-card border border-white/10 bg-[#121218] px-6 py-6 transition-transform duration-200 ease-out hover:-translate-y-1" data-id="element-239" data-mp="1mwyylgoucbpg">
                  <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-full bg-cheer/15" data-id="element-240" data-mp="1cz2ehzdxe6f7">
                    <Icon className="h-5 w-5 text-cheer" aria-hidden="true" data-id="element-241" data-mp="1882hku4t3ocp" />
                  </span>
                  <span data-id="element-242" data-mp="1467i7v6frl1k">
                    <span className="block font-display text-base font-extrabold" data-id="element-243" data-mp="147sebp8efc1j">
                      {feature.title}
                    </span>
                    <span className="mt-1.5 block text-sm leading-relaxed text-white/60" data-id="element-244" data-mp="u8tbwoe88cmz">
                      {feature.description}
                    </span>
                  </span>
                </li>
              </Reveal>;
        })}
        </ul>
      </div>
    </section>;
}